'use strict';

import { getVueTemplate } from '../../../../_imports/utils/utils.common';
import ResourceCardCommon from '../_imports/shared/resource-card.common';

const resourceCardHorizontalTopPicks = {
    template: getVueTemplate('resource-card-horizontal-top-picks'),
    mixins: [ResourceCardCommon],
};

export default resourceCardHorizontalTopPicks;